"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Ably = _interopRequireWildcard(require("ably"));

var _enforceDefaultClientOptions = require("./enforceDefaultClientOptions");

var HubSpotAbly = {
  Rest: Ably.Rest,
  msgpack: Ably.msgpack,
  Realtime: (0, _enforceDefaultClientOptions.enforceDefaultClientOptions)(Ably.Realtime)
};
var _default = HubSpotAbly;
exports.default = _default;
module.exports = exports.default;